import React, { createContext, useState, useEffect } from '../../_snowpack/pkg/react.js';
import { useQuery } from '../../_snowpack/pkg/@apollo/react-hooks.js';
import isEmpty from '../../_snowpack/pkg/lodash/isEmpty.js';
import config from '../app-config.js';
import { GET_ME_AND_TENANTS } from '../queries/index.js';
// @ts-expect-error
import { hide } from '../booting.js';
import useLocalStorage from './useLocalStorage.js';
const defaultUserContext = {
  language: null,
  appPlugins: [],
  tenant: null,
  tenants: null,
  user: null
}; // @ts-expect-error

export const UserContext = /*#__PURE__*/createContext(defaultUserContext);
UserContext.displayName = 'UserContext';
export function UserProvider({
  children
}) {
  // local storage tenant is needed so we can land on the selected tenant, not always on the first tenant
  const [lsTenant, setLSTenant] = useLocalStorage('crystallize:tenant');
  const [lsLanguage, setLSLanguage] = useLocalStorage('crystallize:language');
  const [appPlugins, setAppPlugins] = useLocalStorage('crystallize:appPlugins', []);
  const {
    data,
    loading,
    refetch,
    error
  } = useQuery(GET_ME_AND_TENANTS, {
    fetchPolicy: 'network-only'
  }); //  TODO: how to allow the tenant to start as null?
  // @ts-expect-error

  const [tenant, setTenant] = useState(null); //  TODO: how to allow the language to start as null?
  // @ts-expect-error

  const [language, setLanguage] = useState(null);
  const {
    tenants,
    ...user
  } = (data === null || data === void 0 ? void 0 : data.me) || {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  function saveAppPlugins(newPlugins) {
    setAppPlugins(newPlugins);
  }

  useEffect(() => {
    var _data$me$tenants$0$te, _data$me2, _data$me2$tenants, _data$me2$tenants$;

    if (loading) {
      return;
    } // Cypress provides a tenant override while running


    if (config.TENANT_OVERRIDE) {
      var _data$me$tenants$find, _data$me, _data$me$tenants, _cyTenant$defaults, _config$TENANT_OVERRI;

      const {
        tenant: cyTenant
      } = (_data$me$tenants$find = data === null || data === void 0 ? void 0 : (_data$me = data.me) === null || _data$me === void 0 ? void 0 : (_data$me$tenants = _data$me.tenants) === null || _data$me$tenants === void 0 ? void 0 : _data$me$tenants.find(({
        tenant: t
      }) => t.id === config.TENANT_OVERRIDE.id)) !== null && _data$me$tenants$find !== void 0 ? _data$me$tenants$find : {};
      const tenantLanguage = lsLanguage ? lsLanguage : cyTenant ? (_cyTenant$defaults = cyTenant.defaults) === null || _cyTenant$defaults === void 0 ? void 0 : _cyTenant$defaults.language : (_config$TENANT_OVERRI = config.TENANT_OVERRIDE.defaults) === null || _config$TENANT_OVERRI === void 0 ? void 0 : _config$TENANT_OVERRI.language; // @ts-expect-error

      setTenant(cyTenant);
      setLSTenant(cyTenant);
      setLanguage(tenantLanguage);
      setLSLanguage(tenantLanguage);
      return;
    }

    const defaultNetworkTenant = (_data$me$tenants$0$te = data === null || data === void 0 ? void 0 : (_data$me2 = data.me) === null || _data$me2 === void 0 ? void 0 : (_data$me2$tenants = _data$me2.tenants) === null || _data$me2$tenants === void 0 ? void 0 : (_data$me2$tenants$ = _data$me2$tenants[0]) === null || _data$me2$tenants$ === void 0 ? void 0 : _data$me2$tenants$.tenant) !== null && _data$me$tenants$0$te !== void 0 ? _data$me$tenants$0$te : {}; // new user

    if (isEmpty(lsTenant) && isEmpty(defaultNetworkTenant)) {
      return setTenant({});
    } // no tenant found on local storage set the default network tenant


    if (isEmpty(lsTenant) && !isEmpty(defaultNetworkTenant) && !isEmpty(defaultNetworkTenant.defaults)) {
      var _defaultNetworkTenant, _defaultNetworkTenant2;

      setTenant(defaultNetworkTenant);
      setLSTenant(defaultNetworkTenant.id);
      setLanguage((_defaultNetworkTenant = defaultNetworkTenant.defaults) === null || _defaultNetworkTenant === void 0 ? void 0 : _defaultNetworkTenant.language);
      setLSLanguage((_defaultNetworkTenant2 = defaultNetworkTenant.defaults) === null || _defaultNetworkTenant2 === void 0 ? void 0 : _defaultNetworkTenant2.language);
      return;
    } // we've got a local storage tenant.


    if (!isEmpty(lsTenant)) {
      var _data$me$tenants$find2, _data$me3, _data$me3$tenants, _networkTenant$defaul, _defaultNetworkTenant3;

      const {
        tenant: networkTenant
      } = (_data$me$tenants$find2 = data === null || data === void 0 ? void 0 : (_data$me3 = data.me) === null || _data$me3 === void 0 ? void 0 : (_data$me3$tenants = _data$me3.tenants) === null || _data$me3$tenants === void 0 ? void 0 : _data$me3$tenants.find(({
        tenant: t
      }) => t.id === lsTenant)) !== null && _data$me$tenants$find2 !== void 0 ? _data$me$tenants$find2 : {};
      const tenantLanguage = lsLanguage ? lsLanguage : networkTenant ? (_networkTenant$defaul = networkTenant.defaults) === null || _networkTenant$defaul === void 0 ? void 0 : _networkTenant$defaul.language : (_defaultNetworkTenant3 = defaultNetworkTenant.defaults) === null || _defaultNetworkTenant3 === void 0 ? void 0 : _defaultNetworkTenant3.language; // unfortunately the local storage tenant doesn't belong to the user, set the default network tenant

      if (isEmpty(networkTenant)) {
        setTenant(defaultNetworkTenant);
        setLSTenant(defaultNetworkTenant.id);
        setLanguage(tenantLanguage);
        setLSLanguage(tenantLanguage);
        return;
      } // it's safe to set the network tenant


      if (networkTenant) {
        setTenant(networkTenant);
        setLSTenant(networkTenant.id);
        setLanguage(tenantLanguage);
        setLSLanguage(tenantLanguage);
      }
    } // if we add the remaining dependencies, we enter in a endless cycle
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [loading, data]); // update local storage tenant when tenant changes

  useEffect(() => {
    // tenant is not set yet
    if (loading || error || !tenant) {
      return;
    }

    const tenantId = tenant.id;
    /**
     * tenant has changed, update:
     * local storage tenant
     * local storage language
     * language
     */

    if (tenantId !== lsTenant) {
      var _tenant$defaults, _tenant$defaults2;

      setLSTenant(tenantId);
      setLSLanguage((_tenant$defaults = tenant.defaults) === null || _tenant$defaults === void 0 ? void 0 : _tenant$defaults.language);
      setLanguage((_tenant$defaults2 = tenant.defaults) === null || _tenant$defaults2 === void 0 ? void 0 : _tenant$defaults2.language);
    } // if we add the remaining dependencies, we enter in a endless cycle
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [tenant]); // update local storage language when language changes

  useEffect(() => {
    if (loading || error || !language) {
      return;
    }

    if (language !== lsLanguage) {
      setLSLanguage(language);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [language]); //* NOTE: empty ({}) tenant is valid, since it could be a new user

  if (loading) {
    return null;
  } // safe to remove the loading


  hide();
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      appPlugins,
      language,
      refetch,
      saveAppPlugins,
      setLanguage,
      setTenant,
      tenant,
      tenants,
      user: user
    }
  }, children);
}